import React, { useState, useContext } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { useForm, Resolver } from "react-hook-form"
import API from '../API'
import { DayAllocated, UserDeleteEntryType, UserUpdateEntryType } from '../interfaces';
import { getDayOfWeekName, lookupNameFromObjectsArray } from '../global'
import { SaveDayResponse, ReportingData, ReportingDataDay, DeleteDayResponse, QueryTimeReportRows, InitData, QueryActivities } from '../../../backend/src/api/dto';

type FormValues = {
    hours: string
    activityId: string
}




function ModalUserAddEditDayEntry({ item, day, activity, hours, initData, currentData, dayAllocated, updateEntry, deleteEntry }: {
    item: QueryTimeReportRows,
    day: ReportingDataDay,
    activity: QueryActivities,
    hours: number | null
    initData: InitData,
    currentData: ReportingData,
    dayAllocated: DayAllocated,
    updateEntry: UserUpdateEntryType,
    deleteEntry: UserDeleteEntryType
}) {

    const [showModal, closeModal] = useContext(ModalContext);
    const { register, handleSubmit, getValues } = useForm<FormValues>({
        defaultValues: {
            hours: (hours ? String(hours) : ""),
            activityId: (activity.activityId ? String(activity.activityId) : ""),
        }
    })

    const [loading, setLoading] = useState(false);
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => {
                doSubmit()

            },
            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];

    const doSubmit = () => {


        setLoading(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data) => {
                const hoursValue = parseInt(data.hours);
                const activityIdValue = data.activityId ? parseInt(data.activityId, 10) : 0;

                if (Number.isInteger(hoursValue) && hoursValue > 0) {
                    API.userSetDay(item.timeReportRowId, day.day, hoursValue, activityIdValue).then((data2: SaveDayResponse) => {
                        setLoading(false);
                        setApiResult({
                            status: true,
                        })
                        updateEntry(data2.day, data2.timeReportRowId, data2.hours, data2.timeReportEntryId, data2.activityId)
                        closeModal(null);
                        resolve(1)
                    }).catch((e) => {
                        setLoading(false);
                        setApiResult(e)
                        resolve(1)
                    })
                } else {
                    API.userDeleteDay(item.timeReportRowId, day.day, activity.activityId ?? 0).then((data2: DeleteDayResponse) => {
                        setLoading(false);
                        setApiResult({
                            status: true,
                        })
                        deleteEntry(data2.day, data2.timeReportRowId, activity.activityId)
                        closeModal(null);
                        resolve(1)
                    }).catch((e) => {
                        setLoading(false);
                        setApiResult(e)
                        resolve(1)
                    })
                }
            })()
        })

    }


    const onSubmit = (event: React.SyntheticEvent<HTMLFormElement>) => {
        event.preventDefault();
        doSubmit()
        return false
    }



    return (



        <Modal
            buttons={modalButtons}
            title={'Upraviť jeden záznam'}
            errorObject={apiResult}
            disableAllButtons={loading}
        >
            <form onSubmit={onSubmit}>
                <div className="row mb-2">
                    <div className="col-5 text-end mt-1">
                        Hodiny
                    </div>
                    <div className="col-3">
                        <div className="input-group">
                            <input autoFocus  {...register("hours")} className="form-control form-control-sm" />
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-5 text-end">
                        Deň
                    </div>
                    <div className="col-7">
                        <strong>{day.day}</strong>.{currentData.month}.{currentData.year}
                        &nbsp;&nbsp;
                        <small className="text-muted">{getDayOfWeekName(day.dayOfWeek)}</small>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-5 text-end">
                        Projekt
                    </div>
                    <div className="col-7">
                        {item.projectName}
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-5 text-end">
                        Komponent
                    </div>
                    <div className="col-7">
                        {item.orderName}
                    </div>
                </div>
                {
                    item.withActivities ?

                        <div className="row mb-2">
                            <div className="col-5 text-end mt-2">
                                Aktivita
                            </div>
                            <div className="col-7">
                                <select className="form-select" {...register("activityId")} >
                                    {
                                        initData.activities.map(act => {
                                            return (
                                                <option value={act.activityId}>{act.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        :
                        null
                }

            </form>
        </Modal>


    )

}

export default ModalUserAddEditDayEntry
